import http from "./httpService";

export default async function getCustomerDetailsByIp(ipAddress: string) {
  try {
    const res = await http.get(
      `/api/CustomerDetailsbyIP/CustomerDetailsbyIP?ipaddress=${ipAddress}`
    );
    return res.data?.data[0][0];
  } catch (err) {
    console.log(err);
  }
}

export async function checkBrowsePackageAvailability(customerId: string) {
  try {
    const res = await http.get(
      `/api/check_browse_package_availability/check_browse_package_availability?customer_id=${customerId}`
    );
    return res.data;
  } catch (err) {
    console.log(err);
    return null
  }
}

export async function checkBookBrowsePackageAvailability(customerId: string) {
  try {
    const res = await http.get(
      `/api/check_book_package_availability/check_book_package_availability?customer_id=${customerId}`
    );
    return res.data;
  } catch (err) {
    console.log(err);
    return null
  }
}


